import { View, useTheme, Loader, Grid } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import TableComponent from './commons/TableComponent';
import { useEffect, useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { getUserByUsernameWithProjects } from './custom_queries';
import ModalView from './commons/ModalView';
import HomeViewPageProject from './HomeViewPageProject';


const LIMIT_PROYECTS_BY_PAGE = 4;
const client = generateClient();

function HomePageCurrentUser(props) {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [selectProject, setSelectProject] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [nextToken, setNextToken] = useState(null);
    const [prevTokens, setPrevTokens] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [popup, setPopup] = useState(false);
    const [isTemporal, setIsTemporal] = useState(true);
    const [temporalComponent, setTemporalComponent] = useState();

    const { tokens } = useTheme();

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setPrevTokens([...prevTokens, nextToken]);
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newPrevTokens = prevTokens.slice(0, -1);
            setNextToken(newPrevTokens[newPrevTokens.length - 1] || null);
            setPrevTokens(newPrevTokens);
            setCurrentPage(currentPage - 1);
        }
    };

    const fetchUserProjects = async () => {
        try {
            const userProjectsResult = await fetchProjects(props.username);
            const userProjectsResultUpdated = userProjectsResult.map((project) => project.project);
            setProjects(userProjectsResultUpdated); // Actualiza el estado de proyectos
            const totalPagesCalculated = Math.ceil(userProjectsResultUpdated.length / LIMIT_PROYECTS_BY_PAGE);
            setTotalPages(totalPagesCalculated);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const fetchProjects = async (username) => {
        try {
            const response = await client.graphql({
                query: getUserByUsernameWithProjects,
                variables: {
                    username: username
                }
            });
            return response.data.getUserByUsername.items[0].projects.items;
        } catch (e) {
            console.log('Something went wrong', e);
            return [];
        }
    };

    const handlerTemporal = (type) => {
        if (type === 'loader') {
            handlerLoader();
        }
    }

    const handlerLoader = () => {
        setTimeout(() => {
            setIsTemporal(false);
        }, 2000);

        setTemporalComponent(
            <Loader
                variation="linear"
                emptyColor={tokens.colors.gray}
                filledColor={'#588292'}
            />)
    }

    useEffect(() => {
        fetchUserProjects(props.username);
        handlerTemporal("loader");
    }, []);

    const handlerClickOnObject = async (projectId) => {
        setPopup(true);
        const selectProjectData = projects.filter((project) => project.id === projectId)[0]
        setSelectProject(selectProjectData);
    };

    const closePopup = async () => {
        // reloadProjects();
        setPopup(false);
    };


    return (
        <div className="container">
            {isTemporal ? (
                <div className="container">
                    <Grid
                        templateColumns="10fr"
                        templateRows="10rem"
                    >
                        {temporalComponent}
                    </Grid></div>) : (
                <>
                    <TableComponent
                        error={''}
                        value={'Name'}
                        objects={projects}
                        handlerClickOnObject={handlerClickOnObject}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handleNextPage={handleNextPage}
                        handlePreviousPage={handlePreviousPage}
                        nameObject={'name'}
                    />

                    <ModalView isOpen={popup} onClose={closePopup} type='modal-content-view'>
                        <View style={formStyle} font="font.inverse">
                            <HomeViewPageProject
                                selectProject={selectProject}
                                onCancel={closePopup}
                                role={props.role}
                            />
                        </View>
                    </ModalView>
                </>
            )}

        </div>
    );
}

const formStyle = {
    // padding: '50px 20px',
    backgroundColor: '#282c34',
    padding: '1rem',
    width: '30rem',
    height: '28rem',
    color: 'white'
};

export default HomePageCurrentUser;
